import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-questionnaire-question";

const keys = addTranslations(RESOURCE_NAME, {
    unavailable_translation: {
        en: "Unavailable translation",
        fr: "Traduction non disponible",
    },
    comment_placeholder: {
        en: "Note",
        fr: "Note",
    },

    text_placeholder: {
        en: "Type your answer here",
        fr: "Répondez ici",
    },

    value_placeholder: {
        en: "Type your answer here",
        fr: "Répondez ici",
    },

    value_unit_placeholder: {
        en: "Type your answer here ({{unit}})",
        fr: "Répondez ici ({{unit}})",
    },

    evidence_files: {
        en: "Documents",
        fr: "Documents",
    },

    comment_error: {
        en: "Please explain why this question does not apply to your case.",
        fr: "Veuillez expliquer pourquoi cette question ne s’applique pas à votre cas.",
    },

    successfully_updated: {
        en: "Successfully updated",
        fr: "Modifications enregistrées",
    },

    update_error: {
        en: "Failed to update",
        fr: "Erreur lors de la modification",
    },

    option_non_available_in_locale: {
        en: "Option non available in current locale",
        fr: "Option non disponible dans la langue courante",
    },

    no_data_switch_label: {
        en: "Not applicable",
        fr: "Non applicable",
    },
    no_data_switch_tooltip: {
        en: "Check this if the question is not relevant to your situation or activities.",
        fr: "Cochez si la question ne s’applique pas à votre situation ou vos activités.",
    },
    reset_validation: { en: "Edit", fr: "Modifier" },
    reset_answer: { en: "Reset question", fr: "Réinitialiser la question" },
    validate_answer: { en: "Complete", fr: "Compléter" },
    validate_answer_tooltip: {
        en: "To complete this question, you need to provide an answer and a proof if required. If your question is not applicable, you can use the 'Not applicable' option and provide a comment.",
        fr: "Pour compléter cette question, vous devez fournir une réponse ou une preuve si nécessaire. Si votre question n'est pas applicable, vous pouvez utiliser l'option 'Non applicable' et fournir un commentaire.",
    },
    delete_comment: {
        en: "Delete comment",
        fr: "Supprimer le commentaire",
    },
    missing_proof_warning: {
        en: "This field is required",
        fr: "Ce champ est obligatoire",
    },
});

export function useSupplierQuestionnaireQuestionTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
